import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  returnMethodFromModel,
  validateReturnMethodCondition,
  type ReturnMethodState,
} from "@redotech/redo-model/return-flow/condition-validate";
import { ReturnOptionMethod } from "@redotech/redo-model/return-flow/return-option";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const getLabelForReturnOption = (option: ReturnOptionMethod["type"]) => {
  return option === ReturnOptionMethod.EXCHANGE
    ? "Exchange"
    : option === ReturnOptionMethod.STORE_CREDIT
      ? "Store credit"
      : "Refund";
};

export const RETURN_METHOD = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ReturnMethodState>>,
): ConditionType<ReturnMethodState, Condition.ReturnMethod> => ({
  name: "Return method",
  description(state) {
    return `Return method = ${getLabelForReturnOption(state.returnMethod)}`;
  },
  Details(props: ConditionTypeDetailsProps<ReturnMethodState>) {
    return React.createElement(Details, props);
  },
  empty: { returnMethod: ReturnOptionMethod.EXCHANGE },
  fromModel(model) {
    return returnMethodFromModel(model);
  },
  toModel(state) {
    return { type: Condition.RETURN_METHOD, returnMethod: state.returnMethod };
  },
  valid(state) {
    return validateReturnMethodCondition(state).valid;
  },
});

export { type ReturnMethodState } from "@redotech/redo-model/return-flow/condition-validate";
